import React from 'react';
import styles from './index.module.less';

const BottomCta: React.FC<any> = ({ content }) => {
  const showContent = content.contentInfo['section-bottom-cta'];
  if (!showContent.title) {
    return null;
  }
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>{showContent.title}</h2>
        <p className={styles.desc}>{showContent.desc}</p>
        <div
          className={styles.btn}
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }}
        >
          {showContent.btnStr}
        </div>
      </div>
    </div>
  );
};

export default BottomCta;
